// specific to SA
import Component from '../../UM-Base/components/Component';
import { UserManager } from 'oidc-client';

export default class OidcSilentSignin extends Component {
  load() {
    console.log('OidcSilentSignin.');

    // TODO: Create new route in Umbraco and only run this code for silent callback
    var mgr = new UserManager();
    mgr.signinSilentCallback();

    // new UserManager({
    //   response_mode: 'query'
    // }).signoutPopupCallback();

    super.load();
  }
}
